import React from 'react'

import { Button, TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, shape, number, string, node } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import { formatMoneyValue } from '../../../formatter'

function formatAmount(value) {
  return value > 0 ? `$${formatMoneyValue(value)}` : '-'
}

function EarningsStatCard({ label, amount, badge = null, subContent = null }) {
  return (
    <div className="overview-stats-group__section">
      <div className="overview-stats-group__section-header">
        <span className="overview-stats-group__label cgt-text-caption">{label}</span>
        {badge}
      </div>
      <div className="overview-stats-group__amount cgt-heading-h4">{amount}</div>
      {subContent}
    </div>
  )
}

EarningsStatCard.propTypes = {
  label: string.isRequired,
  amount: string.isRequired,
  badge: node,
  subContent: node,
}

function EarningsStatsGroup({
  tiles = null,
  isSubscriptionParticipant = false,
  onEnableSubscription = NOOP,
  onViewSubscriptionDetails = NOOP,
  onViewRegularDetails = NOOP,
}) {
  const {
    totalEarnings = 0,
    regularPeriodTotal = 0,
    subscriptionPeriodTotal = 0,
    periodLabel = '',
  } = tiles || {}

  return (
    <div className="overview-stats-group">
      <div className="overview-stats-group__total">
        <div className="overview-stats-group__label cgt-text-caption">TOTAL EARNINGS</div>
        <div className="overview-stats-group__total-amount cgt-heading-h4">
          {formatAmount(totalEarnings)}
        </div>
      </div>

      <div className="overview-stats-group__detail">
        <EarningsStatCard
          label="REGULAR EARNINGS"
          amount={formatAmount(regularPeriodTotal)}
          subContent={(
            <div className="cgt-text-medium overview-stats-group__sub-text">
              {periodLabel}
              {' '}
              <Button
                type="ghost-primary"
                size="small"
                customClass="overview-stats-group__link"
                onClick={onViewRegularDetails}
              >
                View details
              </Button>
            </div>
          )}
        />

        <div className="overview-stats-group__divider" />

        <EarningsStatCard
          label="SUBSCRIPTION EARNINGS"
          amount={formatAmount(subscriptionPeriodTotal)}
          badge={!isSubscriptionParticipant ? (
            <TagComponent color="grey" type="ghost" small>Not participating</TagComponent>
          ) : null}
          subContent={isSubscriptionParticipant ? (
            <div className="cgt-text-medium overview-stats-group__sub-text">
              {periodLabel}
              {' '}
              <Button
                type="ghost-primary"
                size="small"
                customClass="overview-stats-group__link"
                onClick={onViewSubscriptionDetails}
              >
                View details
              </Button>
            </div>
          ) : (
            <div className="cgt-text-medium">
              <Button
                type="ghost-primary"
                size="small"
                customClass="overview-stats-group__link"
                onClick={onEnableSubscription}
              >
                Enable Maximize Earnings
              </Button>
            </div>
          )}
        />
      </div>
    </div>
  )
}

EarningsStatsGroup.propTypes = {
  tiles: shape({
    totalEarnings: number,
    regularPeriodTotal: number,
    subscriptionPeriodTotal: number,
    periodLabel: string,
  }),
  isSubscriptionParticipant: bool,
  onEnableSubscription: func,
  onViewSubscriptionDetails: func,
  onViewRegularDetails: func,
}

export default EarningsStatsGroup
